<template>
  <full-screen-slide
    class="page-404"
    v-if="image"
    v-bind:background-image-src="image.image"
    v-bind:overlay-color="'rgba(0, 0, 0, 0.5)'"
  >
    <div class="text-block">
      <h1>{{ image.title }}</h1>
      <p class="not-found-text">{{ image.description }}</p>
      <nav class="links-wrapper">
        <router-link to="/">Вернуться на сайт</router-link>
        <router-link to="/contacts">Контакты</router-link>
      </nav>
    </div>
  </full-screen-slide>
</template>

<script>
import FullScreenSlide from '../components/the-content/utils/FullScreenSlide'

export default {
  name: 'Page404',
  components: {FullScreenSlide},
  data () {
    return {
      image: {}
    }
  },
  metaInfo: {
    title: 'Страница не найдена',
    titleTemplate: null,
    meta: [
      {
        name: 'description',
        content: 'Запрашиваемая страница не найдена'
      }
    ]
  },
  computed: {
    backgroundImageStyle: function () {
      return this.image ? {backgroundImage: `url('${this.image.image}')`} : {}
    }
  },
  beforeRouteEnter (to, from, next) {
    // Unexpectedly VueMeta doesn't update the meta tag specified in index.html
    const robotsMeta = document.querySelector('head meta[name="robots"]')
    robotsMeta.setAttribute('content', 'noindex')
    next()
  },
  beforeRouteLeave (to, from, next) {
    const robotsMeta = document.querySelector('head meta[name="robots"]')
    robotsMeta.setAttribute('content', 'index, follow')
    next()
  },
  mounted () {
    this.get404Image()
  },
  updated () {
    if (Object.keys(this.image).length > 0 && window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  methods: {
    get404Image: function () {
      const uri = `${process.env.API_HOST}/api/v1/images/get-images-by-tags`
      this.$http
        .get(uri, {params: {include_tags: '404-page'}})
        .then(response => { this.image = response.body[0] })
    }
  }
}
</script>

<style scoped lang="scss">
  .page-404 {
    .text-block {
      @include text-block();
      & > h1, .not-found-text {
        margin-bottom: 0.67em;
        text-align: center;
      }
      & > .links-wrapper {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        & > a {
          margin: 0.5em;
          @include framed-color-reversible-button();
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Page404.vue